/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */
/* eslint-disable */

import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { translate } from "react-i18next";
import "./headerStyles.css";

import { ExpandMore, AccountBoxOutlined } from "@mui/icons-material";

import { Tooltip, Zoom, Button } from "@mui/material";

import LogoIcon from "../../../assets/logos/motcos_logo.svg";
import MyAccountMenu from "../../../components/menus/MyAccountMenu";
import LoginMenu from "../../../components/menus/LoginMenu/LoginMenu";
import i18n from "../../../services/i18n";
import STATIC_ROUTES from "../../../route/STATIC_ROUTES";
import { actions as AppActions, getAppSettings, getLanguage } from "../../../reducers/app";
import { getAuthentication, getUserData } from "../../../reducers/auth";
import { ROLES } from "../../../config";
import MaintenanceBanner from "../../../components/widgets/MaintenanceBanner";
import MenuIcon from "@mui/icons-material/Menu";

interface Props {
  isMobile: boolean;
  classes: Object;
  setCountry: () => void;
  isAuthenticated: boolean;
  history: Object;
  // user: Object
}

const Header = React.memo((props: Props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElLoginMenu, setAnchorElLoginMenu] = useState(null);

  const history = useHistory();

  const { isAuthenticated, user } = useSelector((globalState) => ({
    app: getAppSettings(globalState),
    isAuthenticated: getAuthentication(globalState),
    user: getUserData(globalState),
    language: getLanguage(globalState),
  }));

  const open = Boolean(anchorEl);
  const openLoginMenu = Boolean(anchorElLoginMenu);

  function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
    // setAnchorLanguageEl(null);
  }

  function handleClick(link, handle = false) {
    history.push(link);
    if (handle) {
      handleClose();
    }
  }

  const handleLoginMenuClick = (event) => {
    setAnchorElLoginMenu(event.currentTarget);
  };

  const handleLoginMenuClose = () => {
    setAnchorElLoginMenu(null);
  };

  return (
    <div className="header_wrapper">
      <MaintenanceBanner />
      <div className="header_container">
        <div
          className="logo_container"
          onClick={() => {
            handleClick(isAuthenticated ? STATIC_ROUTES.dashboard : STATIC_ROUTES.landingPage);
          }}
        >
          <img alt="MotCoS Logo" src={LogoIcon} className="logo" />
        </div>
        <nav className="nav_container">
          <ul>
            <li>
              {isAuthenticated ? (
                <div>
                  <Tooltip
                    title={i18n.t("core:myProfile")}
                    aria-label="profile"
                    TransitionComponent={Zoom}
                    arrow={true}
                  >
                    <Button
                      aria-owns={open ? "headerMenuAppBar" : null}
                      aria-haspopup="true"
                      onClick={handleMenu}
                      color="inherit"
                      startIcon={<AccountBoxOutlined />}
                      endIcon={<ExpandMore />}
                    >
                      {user.user && user.user.firstName + " " + user.user.lastName}
                    </Button>
                  </Tooltip>

                  <MyAccountMenu
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    handleClick={handleClick}
                    userName={user.user.name}
                    isAdminAccess={isAuthenticated && user.user.role === ROLES.SUPER_ADMIN}
                  />
                </div>
              ) : (
                <>
                  <button className="account_button" onClick={handleLoginMenuClick}>
                    {i18n.t("core:simpleLogin")}
                  </button>
                  <LoginMenu
                    open={openLoginMenu}
                    anchorEl={anchorElLoginMenu}
                    onClose={handleLoginMenuClose}
                  />
                </>
              )}
            </li>
            {/* <li>
              <button className="link_button">{i18n.t("core:simpleFAQ")}</button>
            </li> */}
          </ul>
        </nav>
        <nav className="nav_container_hamburger">
          {/* TODO: Hamburger menu */}
          <MenuIcon />
        </nav>
      </div>
    </div>
  );
});

export default translate(["core"], { wait: true })(Header);
